module.exports = __webpack_public_path__ + "img/C3.a432fbfa.png";